import firebase from 'firebase'

import { ExtSettingsType } from 'app/types'
import { ORG_SHARE_OPTIONS } from 'hooks'

const orgRef = (id: string) => firebase.firestore().doc(`organizations/${id}`)

export type OrgType = {
    name: string
    logo: string
    domains: Array<string>
    id: string
    ownerAgency: string
    accountOwners: string
    defaultSharingSettings?: keyof typeof ORG_SHARE_OPTIONS
}

export const pendingUserRef = (orgId: string, email: string) =>
    firebase.firestore().doc(`/usersPerOrg/${orgId}/pendingUsers/${email}`)

export const updatePendingUserInvitationTime = (orgId: string, email: string) => {
    return pendingUserRef(orgId, email).update({ sentAt: Date.now() })
}

export const createOrganization = ({
    defaultSharingSettings = ORG_SHARE_OPTIONS.public,
    ...org
}: OrgType) => {
    return orgRef(org.id)
        .set({ ...org, defaultSharingSettings })
        .catch(console.error)
}

export const getOrgById = (myOrgId: string, customerOrgId: string) =>
    firebase
        .firestore()
        .collection(`usersPerOrg/${myOrgId}/customers`)
        .doc(customerOrgId)
        .get()
        .then(res => res.data())

export const removeUserFromOrg = ({
    orgId,
    docId,
    isPending
}: {
    orgId: string
    docId: string
    isPending?: boolean
}) => {
    const userCollection = isPending ? 'pendingUsers' : 'users'

    return firebase
        .firestore()
        .collection(`usersPerOrg/${orgId}/${userCollection}`)
        .doc(docId)
        .delete()
        .catch(console.error)
}

export const updateOrganization = ({ id, ...rest }: { id: string; [key: string]: any }) => {
    return orgRef(id).update(rest).catch(console.error)
}

export const updateExtSettings = (
    orgId: string,
    type: 'chrome' | 'edge',
    settings: ExtSettingsType
) => {
    return orgRef(orgId).update(type, settings)
}
export const setExtSettings = (
    orgId: string,
    type: 'chrome' | 'edge',
    settings: ExtSettingsType
) => {
    return orgRef(orgId).update(`extSettings.${type}`, settings)
}
